import { FiPlus, FiMinus } from "react-icons/fi";
import SectionTitle from "../../../common/sectionTitle";
import {
  Accordion,
  AccordionItem,
  AccordionTitle,
  AccordionBody,
  IconWrapper,
  OpenIcon,
  CloseIcon,
} from "../../../common/accordion/Accordion";
import faqImage from "../../../assets/images/bg/faq.png";
import data from "../../../assets/data/faq";
import FAQStyleWrapper from "./Faq.style";

const FAQ = () => {
  return (
    <FAQStyleWrapper className="faq_sect" id="faq">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <SectionTitle
              title="General Asked Questions"
              subtitle="FAQ-S"
              className="section_title"
            />

            <div className="left_image">
              <img src={faqImage} alt="faq" />
            </div>
          </div>

          <div className="col-md-6">
            <div className="faq_content">
              <div className="main_faq_questions">
                <Accordion className="faq_questions">
                  {data?.map((item, i) => (
                    <AccordionItem key={i}>
                      <AccordionTitle>
                        <h5>{item.title}</h5>
                        <IconWrapper>
                          <OpenIcon>
                            <FiMinus />
                          </OpenIcon>
                          <CloseIcon>
                            <FiPlus />
                          </CloseIcon>
                        </IconWrapper>
                      </AccordionTitle>
                      <AccordionBody>
                        <p>{item.text}</p>
                      </AccordionBody>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FAQStyleWrapper>
  );
};

export default FAQ;
